<template>

  <div v-if="$route.name!='maintenance'">
    <nav class="navbar is-transparent is-white is-fixed-top has-shadow has-text-weight-bold is-uppercase" :class="isGerman ? 'withBackground' : 'withBackgroundEN'">

    <div class="navbar-brand">

        <router-link :to="isGerman ? '/home' : '/studio-jauschneg-home'" class="navbar-item no-hover" style="color: transparent !important;">
        Zur Homepage<span class="is-hidden-mobile">www.jauschneg.at</span>
        </router-link>

      <div class="navbar-burger burger" 
      data-target="navMenuTransparentExample" 
      @click="showBurger = !showBurger"
      :class="{ 'is-active' : showBurger }">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>

  <div id="navMenuTransparentExample" 
  class="navbar-menu"
  :class="{ 'is-active' : showBurger }">

  <div class="navbar-end">
    <router-link class="navbar-item" :to="isGerman ? '/profil' : '/profile'" @click.native="showMenue">
      {{ isGerman ? 'Profil' : 'About us' }}
    </router-link>
    <router-link class="navbar-item" :to="isGerman ? '/team' : '/the-team'" @click.native="showMenue">
      Team
    </router-link>
    <div class="navbar-item has-dropdown is-hoverable">
    <span class="navbar-link">
      {{ isGerman ? 'Themen' : 'Topics' }}
    </span>
    <div class="navbar-dropdown is-boxed">
          <router-link class="navbar-item" :to="isGerman ? '/themen/freiraum' : '/themen/open-space'" @click.native="showMenue">
            {{ isGerman ? 'Freiraum' : 'Open Space' }}
          </router-link>
          <router-link class="navbar-item" :to="isGerman ? '/themen/landschaft' : '/themen/landscape'" @click.native="showMenue">
            {{ isGerman ? 'Landschaft' : 'Landscape' }}
          </router-link>
          <router-link class="navbar-item" :to="isGerman ? '/themen/mobilitaet' : '/themen/mobility'" @click.native="showMenue">
            {{ isGerman ? 'Mobilität' : 'Mobility' }}
          </router-link>
          <router-link class="navbar-item" :to="isGerman ? '/themen/partizipation' : '/themen/participation'" @click.native="showMenue">
            {{ isGerman ? 'Partizipation' : 'Participation' }}
          </router-link>
          <router-link class="navbar-item" :to="isGerman ? '/themen/gartengestaltung' : '/themen/gartengestaltung'" @click.native="showMenue">
            {{ isGerman ? 'Gartengestaltung' : 'Gartengestaltung' }}
          </router-link>
        </div>
    </div>

    <router-link class="navbar-item" :to="isGerman ? '/projekte' : '/projects'" @click.native="showMenue">
      {{ isGerman ? 'Projekte' : 'Projects' }}
    </router-link>

          <div class="navbar-item">
    <a href="https://at.linkedin.com/in/martina-jauschneg-0a751212" target="_blank">
        <span class="icon">
          <i class="fa fa-lg fa-linkedin-square"></i>
        </span>
    </a>
    <a href="https://www.xing.com/profile/Martina_Jauschneg" target="_blank">
      <span class="icon"><i class="fa fa-lg fa-xing-square ml-4"></i></span>
    </a>
  </div>

  <div class="navbar-item cursor" @click="changeLang()" v-if="isGerman" v-show="$route.name != 'gartengestaltung'">EN</div>
  <div class="navbar-item cursor" @click="changeLang()" v-else v-show="$route.name != 'gartengestaltung'">DE</div>

  </div>

</div>
</nav>

<nav class="navbar is-fixed-top has-shadow is-black" v-if="userIsAuthenticated" style="bottom: 0; top: auto;min-height: 2rem;">
  <div class="navbar-brand" style="min-height: 2rem;">
    <router-link to="/cms/create" title="Neu" class="navbar-item"><span class="icon"><i class="fa fa-md fa-plus-square-o"></i></span></router-link>
    <router-link to="/cms/list" title="Liste" class="navbar-item"><span class="icon"><i class="fa fa-md fa-align-justify"></i></span></router-link>
    <router-link to="/cms/files" title="Dateien" class="navbar-item"><span class="icon"><i class="fa fa-md fa-folder-open-o"></i></span></router-link>
    <a @click="onLogout" title="Logout" class="navbar-item" v-if="userIsAuthenticated"><span class="icon"><i class="fa fa-md fa-sign-out"></i></span></a>
  </div>
</nav>

</div>



</template>

<script>
export default {
  data () {
    return {
      showBurger: false,
      showLang: false
    }
  },
  computed: {
    userIsAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    isGerman () {
      return this.$store.getters.isGerman
    }
  },
  methods: {
    onLogout () {
      this.$store.commit('LOGOUT_USER')
      this.$router.push('/home')
    },
    changeLang () {
      this.$store.commit('changeLang')
    },
    showMenue () {
      this.showBurger = !this.showBurger
    }
  },
  components: {
  }
}
</script>

<style scoped>
.no-hover:hover {
  color: white !important;
  background-color:transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue